import { memo } from 'react';
import { compose } from 'redux';
import { EMPTY_MAP } from 'app/app.constants';
import GoogleMapReact from 'google-map-react';
import GoogleMapTheme from 'layout/googleMap.themes';
import withTheme from '@material-ui/styles/withTheme';

import WellMapMarker from 'features/wells/integrity/wellLocations/WellMapMarker';
import { useCurrentOrganizationMapZoomLevel, useCurrentUserOrganizationLocationDefaultNordway } from 'app/hooks/useCurrentUser';

const WellIntegrityWellLocations = ({
  handleApiLoaded,
  wellbores = EMPTY_MAP,
  theme,
  allowZoom = false,
}) => {
  const { mapZoomLevel } = useCurrentOrganizationMapZoomLevel();
  return (
    <GoogleMapReact
      clusterRadius={1}
      defaultCenter={useCurrentUserOrganizationLocationDefaultNordway()}
      defaultZoom={mapZoomLevel}
      bootstrapURLKeys={{ key: 'AIzaSyBQQk_PZzLUCixr_M6FBW2Yg6y9b5lnHI4' }}
      yesIWantToUseGoogleMapApiInternals
      onGoogleApiLoaded={handleApiLoaded}
      options={{
        draggableCursor: 'inherit',
        styles: GoogleMapTheme[theme.palette.type],
        disableDefaultUI: true,
        gestureHandling: allowZoom ? undefined : 'none',
      }}
    >
      {wellbores.valueSeq().map((wellbore) => {
        const wellboreId = wellbore.get('id');
        const location = wellbore.get('location');

        if (!location) return null;

        const northSouth = location.northSouth;
        const eastWest = location.eastWest;

        return (
          <WellMapMarker
            key={wellboreId}
            lng={eastWest}
            lat={northSouth}
            wellboreId={wellboreId}
          />
        );
      })}
    </GoogleMapReact>
  );
};

export default compose(withTheme, memo)(WellIntegrityWellLocations);
